import React, { useState } from "react";
import QueryBuilder from "../QueryBuilder/Querybuilder";
import logo from "../../assets/logo.png";
import { Button, Modal, Form, Input, Select, message, Row, Col } from "antd";
const Source = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [form] = Form.useForm();
  const onFinish = (values) => {
    console.log("Form Values:", values);
    handleAddSource(values);
  };

  const showModal = () => {
    setModalVisible(true);
  };

  const handleCancel = () => {
    setModalVisible(false);
    form.resetFields();
  };
  const handleAddSource = async (values) => {
    // Extract the source value and structure the data
    const dataToSend = {
      name: values.source,
    };

    try {
      // Assuming an API call to add the source
      const response = await fetch("/api/portal/pms/add_pms_source", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataToSend),
      });

      if (response.ok) {
        message.success("Source added successfully");
        setModalVisible(false); // Close the modal after successful addition
        form.resetFields(); // Reset the form fields
      } else {
        message.error("Failed to add source");
      }
    } catch (error) {
      message.error("Error adding source");
      console.error("Error:", error);
    }
  };
  return (
    <div>
      <Modal
        open={modalVisible}
        onOk={() => form.submit()}
        onCancel={handleCancel}
        title="Public Grievance Form"
        width={800} // Increase the width of the modal
        style={{ top: 20 }} // Adjust the top position of the modal
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={logo}
            style={{ width: 60, marginRight: 20 }}
            alt="Pulse Logo"
          />
          <h2 style={{ margin: 0 }}>Janasena</h2>
        </div>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          style={{ marginTop: 20 }}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="source"
                label="Add Source"
                rules={[
                  { required: true, message: "Please enter your source" },
                ]}
              >
                <Input placeholder="Enter your source" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <QueryBuilder
        title={"Source"}
        Headername={"/api/portal/reports/pms/getTablemetadata/51"}
        Rulesdata={"/api/portal/reports/pms/getFilters/51"}
        Databyquery={"/api/portal/reports/pms/getDatabyquery/51"}
        addsource={true}
        addsourcepet={showModal}
      />
    </div>
  );
};

export default Source;
